import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialProjectItemState: Dtos.ProjectItem & IRegistrationFormState = {
    id: null,
    projectId: null,
    projectItemTemplateId: null,
    projectItemTemplate: null,
    collectionInstanceId: null,
    collectionInstance: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
    search: "",
    dataEntered: null,
    filesAdded: null
}

export interface IProjectItemReduxFormState {
    id: IFieldState<number>,
    projectId: IFieldState<number>,
    projectItemTemplateId: IFieldState<number>,
    collectionInstanceId: IFieldState<number>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    message: IFieldState<string>,
    openedModals: IFieldState<string[]>,
}
